$(document).ready(function(){
    var accordion = {
        accordionArea: document.getElementsByClassName('result-accordion'),
        init: function(){
            accordion.activeEvent();
        },
		accordionToggle: function(e){
			e.preventDefault();
			var $target = $(e.target);

			if( $target.hasClass('active') ){
				$target.removeClass('active');
			} else {
				$target.addClass('active');
			}
			$target.closest('.accordion-box').find('.accordion-desc').collapse('toggle');
		},
		activeEvent: function(){
			// Accordion Toggle
			$(accordion.accordionArea).find('.accordion-title .toggle_text').on('click', accordion.accordionToggle);
        }
    }

    accordion.init();

    function formReset(e){
        var $this = e,
            formThis = $this.parents(".validateForm"),
            chosenSelect = formThis.find(".run-chosen"),
            inputSelect = formThis.find("input:not(.chosen-search-input)"),
            formThisCapacity = formThis.find("select[name='Capacity']"),
            tableResult = formThis.next(".energy-result");
            
        formThisCapacity.children("option:not([disabled])").remove();
        formThisCapacity.attr('disabled', 'disabled');
        
        chosenSelect.val("");
        tableResult.html("");
        chosenSelect.trigger('chosen:updated');
        tableResult.parents(".energy-wrap").find(".energy-compare-result").css({"display":"none"});

        if(!formThis.parents(".energy-box").hasClass("energy-compare")) inputSelect.val("");
    }

    $(".energy-box .field-block").find("input:not(.chosen-search-input)").on("keydown", function(e) {
        if(!((e.keyCode > 95 && e.keyCode < 106)
          || (e.keyCode > 47 && e.keyCode < 58) 
          || (e.keyCode > 36 && e.keyCode < 41) 
          || e.keyCode == 13
          || e.keyCode == 8)
          ) {
            return false;
        }
    })


    $("select[data-url]").on("change", function(){
        var $this = $(this),
            dataUrl = $this.data("url"),
            data = {},
            formThis = $this.parents(".validateForm"),
            formThisCapacity = formThis.find("select[name='Capacity']");
        $this.trigger('chosen:updated');

        var selectVal=$this.val(),
            selectKey=$this.attr("name");

        data[selectKey] = selectVal;
        
        $.ajax({
            type: "get",
            url: dataUrl,
            async: !1,
            dataType: "json",
            data:data,
            success: function(e) {
                formThisCapacity.children("option:not([disabled])").remove();
                formThisCapacity.removeAttr('disabled');

                var obj = e;
                
                for (var prop in obj) {
                    var optionTag = '';

                    optionTag += "<option value='"+ prop +"'>" + obj[prop] + "</option>";
                    formThisCapacity.append(optionTag);
                }
                formThisCapacity.trigger('chosen:updated');
            }
        });
    });
    
    $(".energy-calculator .btn-reset-form").on("click", function(){
        var $this = $(this);
        formReset($this);
    });

    $(".energy-calculator .btn-submit-form").on("click", function(e){
        var $this = $(this),
            formThis = $this.parents(".validateForm");

        e.preventDefault();

        if(formThis.checkValidation()){
            var dataUrl = formThis.data("url"),
                tableResult = formThis.next(".energy-result"),
                formData = formThis.serialize();

            $.ajax({
                type : "get",
                url: dataUrl,
                async: !1,
                dataType: "html",
                data : formData,
                success : function(e){
                    var obj = e;
                    
                    tableResult.html("");
                    tableResult.html(obj);
                    //console.log(obj)
                    if(formThis.parents(".energy-box").hasClass("energy-compare")){
                        tableResult.find(".btn-right").css({"display":"none"});

                        if(!tableResult.find(".title-no-current").length){
                            tableResult.parents(".energy-wrap").find(".energy-compare-result").css({"display":"block"});

                            var resultTableText = formThis.parents(".energy-table").find(".lbl_res_exp");
                            // for(var i=0; i<=resultTableText.length-1; i++){
                                // var compareList = new Array();
                                // compareList[i] = parseInt(resultTableText.eq(i).text());
                            // }
                            var compareResultSum = parseFloat(resultTableText.eq(0).text()) - parseFloat(resultTableText.eq(1).text());
                            tableResult.parents(".energy-wrap").find("#lblfinal").text(String(Math.abs(compareResultSum).toFixed(2)));
                        }
                    }
                    
                    
                    $(".btn-compare-savings").on("click", function(){
                        var $this = $(this),
                            formThis = $this.parents(".energy-box").find(".styled-form"),
                            chosenSelect = formThis.find("select"),
                            inputSelect = $this.parents(".energy-box").find("input:not(.chosen-search-input)"),
                            countChosen = chosenSelect.length,
                            countInput = inputSelect.length;

                        $(".btn-right.btn-submit .btn-submit-form, .btn-right.btn-submit .btn-reset-form").attr('disabled', 'disabled');
                        $this.css({"display":"none"});
                        $(".energy-compare .table-inner").css({"display":"block"});

                        chosenSelect.attr('disabled', 'disabled');
                        inputSelect.attr('disabled', 'disabled');
                        chosenSelect.trigger('chosen:updated');

                        for(var i=0; i<=countInput-1; i++){
                            var inputValue = new Array();
                                inputValue[i] = inputSelect[i].value,
                                $this = $(inputSelect[i]);

                            $this.parents(".energy-table").find(".energy-compare input:not(.chosen-search-input)").val(inputValue[i]).attr('readonly', 'readonly');
                        }
                    })
                }
            })
        }
    })

    $(".energy-calculator .validateForm .field-block").find("select, input").on("change", function(){
        var $this = $(this),
            formThis = $this.parents(".validateForm"),
            energyTableWrap = $this.parents(".energy-wrap");
        formThis.next(".energy-result").html("");
        energyTableWrap.find(".energy-compare-result").css({"display":"none"});
    })

    $(".energy-compare").find(".energy-close").on("click", function(){
        var $this = $(this),
            formThis = $this.parents(".energy-box").find(".styled-form"),
            energyCompareInner = $this.parents(".table-inner"),
            energyTable = $this.parents(".energy-table"),
            energyTableWrap = $this.parents(".energy-wrap"),
            chosenSelect = energyTable.find("select"),
            inputSelect = energyTable.find("input:not(.chosen-search-input)");
        
        energyTable.find(".text-value").remove();
        energyTable.find(".chosen-container, input").css({"display":"block"});
        energyCompareInner.css({"display":"none"});
        energyTableWrap.find(".energy-box").find(".btn-compare-savings").css({"display":"inline-block"});
        $(".btn-right.btn-submit .btn-submit-form, .btn-right.btn-submit .btn-reset-form").removeAttr('disabled');
        chosenSelect.removeAttr("disabled");
        inputSelect.removeAttr("disabled");
        chosenSelect.trigger('chosen:updated');

        formReset($this);
    })

    $("#ElectricityRate").on("input", function(){
        var $this = $(this),
            countMaxLenght = $this.attr("maxlength");

        if($this.val().length > countMaxLenght){
            $this.val($this.val().slice(0, countMaxLenght));
        }
    })


    var countryCode = $("html").attr("data-countrycode").toUpperCase(),
        msg ={
            "DEFAULT": {"LOCALE_CODE":"DEFAULT", "JAVA_LOCALE_CODE":"DEFAULT", "OPEN_WINDOW":"Open New Window", "OPEN_LAYER":"Open layer", "DOWNLOAD_FILE":"Download a file"},
            "AE": {"LOCALE_CODE":"AE", "JAVA_LOCALE_CODE":"en_AE", "OPEN_WINDOW":"Open New Window", "OPEN_LAYER":"Open layer", "DOWNLOAD_FILE":"Download a file"},
            "AE_AR": {"LOCALE_CODE":"AE_AR", "JAVA_LOCALE_CODE":"ar_AE", "OPEN_WINDOW":"افتح نافذة جديدة", "OPEN_LAYER":"افتح الطبقة", "DOWNLOAD_FILE":"تحميل ملف"},
            "AFRICA": {"LOCALE_CODE":"AFRICA", "JAVA_LOCALE_CODE":"en_AFRICA", "OPEN_WINDOW":"Open New Window", "OPEN_LAYER":"Open layer", "DOWNLOAD_FILE":"Download a file"},
            "AR": {"LOCALE_CODE":"AR", "JAVA_LOCALE_CODE":"es_AR", "OPEN_WINDOW":"Abrir en una nueva ventana", "OPEN_LAYER":"Abrir", "DOWNLOAD_FILE":"Descarta el documento"},
            "AT": {"LOCALE_CODE":"AT", "JAVA_LOCALE_CODE":"de_AT", "OPEN_WINDOW":"In neuem Fenster öffnen", "OPEN_LAYER":"Ansicht öffnen", "DOWNLOAD_FILE":"File downloaden"},
            "AU": {"LOCALE_CODE":"AU", "JAVA_LOCALE_CODE":"en_AU", "OPEN_WINDOW":"Open New Window", "OPEN_LAYER":"Open layer", "DOWNLOAD_FILE":"Download a file"},
            "BE_FR": {"LOCALE_CODE":"BE_FR", "JAVA_LOCALE_CODE":"fr_BE", "OPEN_WINDOW":"Ouvrir une Nouvelle Fenêtre", "OPEN_LAYER":"Ouvrir le volet", "DOWNLOAD_FILE":"Télécharger un fichier"},
            "BG": {"LOCALE_CODE":"BG", "JAVA_LOCALE_CODE":"bg_BG", "OPEN_WINDOW":"Отвори нов прозорец", "OPEN_LAYER":"Отвори слой ", "DOWNLOAD_FILE":"Изтегляне на файл"},
            "BR": {"LOCALE_CODE":"BR", "JAVA_LOCALE_CODE":"pt_BR", "OPEN_WINDOW":"Abrir Nova Janela", "OPEN_LAYER":"Abrir Camada", "DOWNLOAD_FILE":"Descargar un archivo"},
            "CA_EN": {"LOCALE_CODE":"CA_EN", "JAVA_LOCALE_CODE":"en_CA", "OPEN_WINDOW":"Open New Window", "OPEN_LAYER":"Open layer", "DOWNLOAD_FILE":"Download a file"},
            "CA_FR": {"LOCALE_CODE":"CA_FR", "JAVA_LOCALE_CODE":"fr_CA", "OPEN_WINDOW":"Ouvrir une nouvelle fenêtre", "OPEN_LAYER":"Ouvrir la couche", "DOWNLOAD_FILE":"Télécharger un fichier"},
            "CH_DE": {"LOCALE_CODE":"CH_DE", "JAVA_LOCALE_CODE":"de_CH", "OPEN_WINDOW":"In neuem Fenster öffnen", "OPEN_LAYER":"Ansicht öffnen", "DOWNLOAD_FILE":"Dateidownload"},
            "CH_FR": {"LOCALE_CODE":"CH_FR", "JAVA_LOCALE_CODE":"fr_CH", "OPEN_WINDOW":"Ouvrir une Nouvelle Fenêtre", "OPEN_LAYER":"Ouvrir onglet", "DOWNLOAD_FILE":"Télécharger un fichier"},
            "CL": {"LOCALE_CODE":"CL", "JAVA_LOCALE_CODE":"es_CL", "OPEN_WINDOW":"Abrir Nueva Ventana ", "OPEN_LAYER":"Abrir Capa ", "DOWNLOAD_FILE":"Descargar archivo "},
            "CN": {"LOCALE_CODE":"CN", "JAVA_LOCALE_CODE":"zh_CN", "OPEN_WINDOW":"打开新窗口", "OPEN_LAYER":"打开层", "DOWNLOAD_FILE":"下载文件"},
            "CO": {"LOCALE_CODE":"CO", "JAVA_LOCALE_CODE":"es_CO", "OPEN_WINDOW":"Abrir una nueva ventana", "OPEN_LAYER":"Capa abierta", "DOWNLOAD_FILE":"Descargar archivo"},
            "CZ": {"LOCALE_CODE":"CZ", "JAVA_LOCALE_CODE":"cs_CZ", "OPEN_WINDOW":"Otevřít nové okno", "OPEN_LAYER":"Otevřít okno", "DOWNLOAD_FILE":"Stáhnout soubor"},
            "DE": {"LOCALE_CODE":"DE", "JAVA_LOCALE_CODE":"de_DE", "OPEN_WINDOW":"In neuem Fenster öffnen", "OPEN_LAYER":"Ansicht öffnen", "DOWNLOAD_FILE":"Dateidownload"},
            "DK": {"LOCALE_CODE":"DK", "JAVA_LOCALE_CODE":"da_DK", "OPEN_WINDOW":"Åben nyt vindue", "OPEN_LAYER":"Åbn lag", "DOWNLOAD_FILE":"Download en fil"},
            "DZ": {"LOCALE_CODE":"DZ", "JAVA_LOCALE_CODE":"fr_DZ", "OPEN_WINDOW":"Ouvrir une Nouvelle Fenêtre", "OPEN_LAYER":"Ouvrir onglet", "DOWNLOAD_FILE":"Télécharger un fichier"},
            "EASTAFRICA": {"LOCALE_CODE":"EASTAFRICA", "JAVA_LOCALE_CODE":"en_KE", "OPEN_WINDOW":"Open New Window", "OPEN_LAYER":"Open layer", "DOWNLOAD_FILE":"Download a file"},
            "EC": {"LOCALE_CODE":"EC", "JAVA_LOCALE_CODE":"es_EC", "OPEN_WINDOW":"Abrir Ventana Nueva", "OPEN_LAYER":"Abrir capa", "DOWNLOAD_FILE":"Descargar un archivo"},
            "EE": {"LOCALE_CODE":"EE", "JAVA_LOCALE_CODE":"et_EE", "OPEN_WINDOW":"Ava uus aken", "OPEN_LAYER":"Ava kiht", "DOWNLOAD_FILE":"Lae alla fail"},
            "EG_AR": {"LOCALE_CODE":"EG_AR", "JAVA_LOCALE_CODE":"ar_EG", "OPEN_WINDOW":"افتح نافذة جديدة", "OPEN_LAYER":"افتح الطبقة", "DOWNLOAD_FILE":"Download a file"},
            "EG_EN": {"LOCALE_CODE":"EG_EN", "JAVA_LOCALE_CODE":"en_EG", "OPEN_WINDOW":"Open New Window", "OPEN_LAYER":"Open layer", "DOWNLOAD_FILE":"Download a file"},
            "ES": {"LOCALE_CODE":"ES", "JAVA_LOCALE_CODE":"es_ES", "OPEN_WINDOW":"Abre ventana nueva", "OPEN_LAYER":"Abrir capa", "DOWNLOAD_FILE":"Descargar archivo"},
            "FI": {"LOCALE_CODE":"FI", "JAVA_LOCALE_CODE":"fi_FI", "OPEN_WINDOW":"Avaa uusi ikkuna", "OPEN_LAYER":"Avaa kerros", "DOWNLOAD_FILE":"Lataa tiedosto"},
            "FR": {"LOCALE_CODE":"FR", "JAVA_LOCALE_CODE":"fr_FR", "OPEN_WINDOW":"Ouvrir une Nouvelle Fenêtre", "OPEN_LAYER":"Ouvrir le volet", "DOWNLOAD_FILE":"Télécharger un fichier"},
            "GR": {"LOCALE_CODE":"GR", "JAVA_LOCALE_CODE":"el_GR", "OPEN_WINDOW":"Ανοίξτε Νέο Παράθυρο", "OPEN_LAYER":"Άνοιγμα επιπέδου", "DOWNLOAD_FILE":"Κατεβάστε ένα αρχείο"},
            "HK": {"LOCALE_CODE":"HK", "JAVA_LOCALE_CODE":"zh_HK", "OPEN_WINDOW":"開啟新視窗", "OPEN_LAYER":"開啟網絡層", "DOWNLOAD_FILE":"下载文件"},
            "HK_EN": {"LOCALE_CODE":"HK_EN", "JAVA_LOCALE_CODE":"en_HK", "OPEN_WINDOW":"Open New Window", "OPEN_LAYER":"Open layer", "DOWNLOAD_FILE":"Download a file"},
            "HR": {"LOCALE_CODE":"HR", "JAVA_LOCALE_CODE":"hr_HR", "OPEN_WINDOW":"Otvori novi prozor", "OPEN_LAYER":"Otvori sloj", "DOWNLOAD_FILE":"Preuzmi datoteku"},
            "HU": {"LOCALE_CODE":"HU", "JAVA_LOCALE_CODE":"hu_HU", "OPEN_WINDOW":"Új ablak megnyitása", "OPEN_LAYER":"Réteg megnyitása", "DOWNLOAD_FILE":"Fájl letöltése "},
            "ID": {"LOCALE_CODE":"ID", "JAVA_LOCALE_CODE":"in_ID", "OPEN_WINDOW":"Buka jendela baru", "OPEN_LAYER":"Buka", "DOWNLOAD_FILE":"Men-download file"},
            "IL": {"LOCALE_CODE":"IL", "JAVA_LOCALE_CODE":"iw_IL", "OPEN_WINDOW":"פתח חלון חדש", "OPEN_LAYER":"פתח שכבה", "DOWNLOAD_FILE":"הורד קובץ"},
            "IN": {"LOCALE_CODE":"IN", "JAVA_LOCALE_CODE":"en_IN", "OPEN_WINDOW":"Open New Window", "OPEN_LAYER":"Open layer", "DOWNLOAD_FILE":"Download a file"},
            "IR": {"LOCALE_CODE":"IR", "JAVA_LOCALE_CODE":"fa_IR", "OPEN_WINDOW":"باز شدن پنجره جدید", "OPEN_LAYER":"لایه باز", "DOWNLOAD_FILE":"دانلود فایل"},
            "IT": {"LOCALE_CODE":"IT", "JAVA_LOCALE_CODE":"it_IT", "OPEN_WINDOW":"Apri una nuova finestra", "OPEN_LAYER":"Apri il layer", "DOWNLOAD_FILE":"Scarica il file / Scarica file"},
            "JP": {"LOCALE_CODE":"JP", "JAVA_LOCALE_CODE":"ja_JP", "OPEN_WINDOW":"新しいウインドウで開く", "OPEN_LAYER":"ウィンドウを開く", "DOWNLOAD_FILE":"ファイルのダウンロード"},
            "KZ": {"LOCALE_CODE":"KZ", "JAVA_LOCALE_CODE":"ru_KZ", "OPEN_WINDOW":"Открыть новое окно", "OPEN_LAYER":"Открыть", "DOWNLOAD_FILE":"Скачать файл"},
            "LEVANT_AR": {"LOCALE_CODE":"LEVANT_AR", "JAVA_LOCALE_CODE":"ar_JO", "OPEN_WINDOW":"افتح نافذة جديدة", "OPEN_LAYER":"افتح الطبقة", "DOWNLOAD_FILE":"تحميل ملف"},
            "LEVANT_EN": {"LOCALE_CODE":"LEVANT_EN", "JAVA_LOCALE_CODE":"en_JO", "OPEN_WINDOW":"Open New Window", "OPEN_LAYER":"Open layer", "DOWNLOAD_FILE":"Download a file"},
            "LK": {"LOCALE_CODE":"LK", "JAVA_LOCALE_CODE":"en_LK", "OPEN_WINDOW":"Open New Window", "OPEN_LAYER":"Open layer", "DOWNLOAD_FILE":"Download a file"},
            "LT": {"LOCALE_CODE":"LT", "JAVA_LOCALE_CODE":"lt_LT", "OPEN_WINDOW":"Atidaryti naują langą", "OPEN_LAYER":"Atidaryti sluoksnį", "DOWNLOAD_FILE":"Atsisiųsti failą"},
            "LV": {"LOCALE_CODE":"LV", "JAVA_LOCALE_CODE":"lv_LV", "OPEN_WINDOW":"Atvērt jaunu logu", "OPEN_LAYER":"Atvērt slāni", "DOWNLOAD_FILE":"Lejupielādēt datni"},
            "MA": {"LOCALE_CODE":"MA", "JAVA_LOCALE_CODE":"fr_MA", "OPEN_WINDOW":"Ouvrir une nouvelle fenêtre", "OPEN_LAYER":"ouvrir couche", "DOWNLOAD_FILE":"Download a file"},
            "MX": {"LOCALE_CODE":"MX", "JAVA_LOCALE_CODE":"es_MX", "OPEN_WINDOW":"Abrir Ventana Nueva", "OPEN_LAYER":"Abrir pestaña", "DOWNLOAD_FILE":"Descargar un archivo"},
            "MY": {"LOCALE_CODE":"MY", "JAVA_LOCALE_CODE":"en_MY", "OPEN_WINDOW":"Open New Window", "OPEN_LAYER":"Open layer", "DOWNLOAD_FILE":"Download a file"},
            "NL": {"LOCALE_CODE":"NL", "JAVA_LOCALE_CODE":"nl_NL", "OPEN_WINDOW":"Open Nieuw Venster", "OPEN_LAYER":"Open laag", "DOWNLOAD_FILE":"Dowload een bestand"},
            "NO": {"LOCALE_CODE":"NO", "JAVA_LOCALE_CODE":"no_NO", "OPEN_WINDOW":"Åpne nytt vindu", "OPEN_LAYER":"Åpne lag", "DOWNLOAD_FILE":"Last ned fil"},
            "NZ": {"LOCALE_CODE":"NZ", "JAVA_LOCALE_CODE":"en_NZ", "OPEN_WINDOW":"Open New Window", "OPEN_LAYER":"Open layer", "DOWNLOAD_FILE":"Download a file"},
            "PA": {"LOCALE_CODE":"PA", "JAVA_LOCALE_CODE":"es_PA", "OPEN_WINDOW":"Abrir una nueva ventana", "OPEN_LAYER":"abrir capa", "DOWNLOAD_FILE":"Descargar un archivo"},
            "PA_EN": {"LOCALE_CODE":"PA_EN", "JAVA_LOCALE_CODE":"en_PA", "OPEN_WINDOW":"Open New Window", "OPEN_LAYER":"Open layer", "DOWNLOAD_FILE":"Download a file"},
            "PE": {"LOCALE_CODE":"PE", "JAVA_LOCALE_CODE":"es_PE", "OPEN_WINDOW":"Abrir nueva ventana", "OPEN_LAYER":"Abrir ventana", "DOWNLOAD_FILE":"Descargar información"},
            "PH": {"LOCALE_CODE":"PH", "JAVA_LOCALE_CODE":"en_PH", "OPEN_WINDOW":"Open New Window", "OPEN_LAYER":"Open layer", "DOWNLOAD_FILE":"Download a file"},
            "PL": {"LOCALE_CODE":"PL", "JAVA_LOCALE_CODE":"pl_PL", "OPEN_WINDOW":"Otwórz nowe okno", "OPEN_LAYER":"Otwórz warstwę", "DOWNLOAD_FILE":"Pobierz plik"},
            "PT": {"LOCALE_CODE":"PT", "JAVA_LOCALE_CODE":"pt_PT", "OPEN_WINDOW":"Abrir nova janela", "OPEN_LAYER":"Abrir", "DOWNLOAD_FILE":"Download um ficheiro"},
            "RO": {"LOCALE_CODE":"RO", "JAVA_LOCALE_CODE":"ro_RO", "OPEN_WINDOW":"Deschide o fereastră nouă", "OPEN_LAYER":"Deschide  ", "DOWNLOAD_FILE":"Descarcă un fişier"},
            "RS": {"LOCALE_CODE":"RS", "JAVA_LOCALE_CODE":"sr_RS", "OPEN_WINDOW":"Otvori novi prozor", "OPEN_LAYER":"Otvori sloj", "DOWNLOAD_FILE":"Download a file"},
            "RU": {"LOCALE_CODE":"RU", "JAVA_LOCALE_CODE":"ru_RU", "OPEN_WINDOW":"Открыть Новое Окно", "OPEN_LAYER":"Открыть", "DOWNLOAD_FILE":"Скачать файл"},
            "SA": {"LOCALE_CODE":"SA", "JAVA_LOCALE_CODE":"ar_SA", "OPEN_WINDOW":"افتح نافذة جديدة", "OPEN_LAYER":"افتح الطبقة", "DOWNLOAD_FILE":"تحميل ملف"},
            "SA_EN": {"LOCALE_CODE":"SA_EN", "JAVA_LOCALE_CODE":"en_SA", "OPEN_WINDOW":"Open New Window", "OPEN_LAYER":"Open layer", "DOWNLOAD_FILE":"Download a file"},
            "SE": {"LOCALE_CODE":"SE", "JAVA_LOCALE_CODE":"sv_SE", "OPEN_WINDOW":"Öppna Nytt Fönter", "OPEN_LAYER":"Öppna lager", "DOWNLOAD_FILE":"Ladda ned en fil"},
            "SG": {"LOCALE_CODE":"SG", "JAVA_LOCALE_CODE":"en_SG", "OPEN_WINDOW":"Open New Window", "OPEN_LAYER":"Open layer", "DOWNLOAD_FILE":"Download a file"},
            "SK": {"LOCALE_CODE":"SK", "JAVA_LOCALE_CODE":"sk_SK", "OPEN_WINDOW":"Otvoriť nové okno", "OPEN_LAYER":"Otvoriť vrstvu", "DOWNLOAD_FILE":"Stiahnuť súbor"},
            "TH": {"LOCALE_CODE":"TH", "JAVA_LOCALE_CODE":"th_TH", "OPEN_WINDOW":"เปิดหน้าต่างใหม่", "OPEN_LAYER":"เปิดเลเยอร์", "DOWNLOAD_FILE":"ดาวน์โหลดไฟล์"},
            "TN": {"LOCALE_CODE":"TN", "JAVA_LOCALE_CODE":"fr_TN", "OPEN_WINDOW":"Ouvrir dans une nouvelle fenêtre", "OPEN_LAYER":"Ouvrir Couche", "DOWNLOAD_FILE":"Télécharger un Fichier"},
            "TR": {"LOCALE_CODE":"TR", "JAVA_LOCALE_CODE":"tr_TR", "OPEN_WINDOW":"Yeni Pencere Aç", "OPEN_LAYER":"Katmanı aç", "DOWNLOAD_FILE":"Dosyayı İndir"},
            "TW": {"LOCALE_CODE":"TW", "JAVA_LOCALE_CODE":"zh_TW", "OPEN_WINDOW":"開新視窗", "OPEN_LAYER":"打開圖層", "DOWNLOAD_FILE":"下載文件"},
            "UA": {"LOCALE_CODE":"UA", "JAVA_LOCALE_CODE":"uk_UA", "OPEN_WINDOW":"Відкрити нове вікно", "OPEN_LAYER":"Відкрити рівень", "DOWNLOAD_FILE":"Завантажити файл"},
            "UK": {"LOCALE_CODE":"UK", "JAVA_LOCALE_CODE":"en_GB", "OPEN_WINDOW":"Open New Window", "OPEN_LAYER":"Open layer", "DOWNLOAD_FILE":"Download a file"},
            "VN": {"LOCALE_CODE":"VN", "JAVA_LOCALE_CODE":"vi_VN", "OPEN_WINDOW":"Mở Cửa Sổ Mới", "OPEN_LAYER":"Mở layer", "DOWNLOAD_FILE":"Tải về"},
            "ZA": {"LOCALE_CODE":"ZA", "JAVA_LOCALE_CODE":"en_ZA", "OPEN_WINDOW":"Open New Window", "OPEN_LAYER":"Open layer", "DOWNLOAD_FILE":"Download a file"}
        }

    function msgTitleInner(){
        //20200525 START 장영희 || COVID Static Contac Us까지 반영
        var $targetObj = $(".support-wrap [title*='{ux_']");
        //20200525 END 장영희 || COVID Static Contac Us까지 반영

        $targetObj.each(function(I){
            var originTitle = $(this).attr("title");
            var changeTitle;

            if(msg.hasOwnProperty(countryCode)){
                changeTitle = originTitle.replace(/{ux_download}/gi, msg[countryCode].DOWNLOAD_FILE)
                                .replace(/{ux_window}/gi, msg[countryCode].OPEN_WINDOW)
                                .replace(/{ux_popup}/gi, msg[countryCode].OPEN_LAYER)
            }else{
                changeTitle =  originTitle.replace(/{ux_download}/gi, msg.DEFAULT.DOWNLOAD_FILE)
                                .replace(/{ux_window}/gi, msg.DEFAULT.OPEN_WINDOW)
                                .replace(/{ux_popup}/gi, msg.DEFAULT.OPEN_LAYER);
            }

            $(this).attr("title", changeTitle);
        })
    }
    msgTitleInner();


   
    //20200311 START 장영희 || Tab, Tabpanel 접근성 속성 추가 (Static Page Tab 공통)
    function tabAriaInner(){
        var $targetRoleTabList = $(".tabs-type-liner[role='tablist'] > li"),
            $targetRoleTab = $(".tabs-type-liner[role='tablist'] [role='tab']"),
            $targetRoleTabPanel = $(".warranty-panel[role='tabpanel']");
        
        var tab = [];
        $targetRoleTab.each(function(I){
            var $thisRoleTab = $(this);
            if($thisRoleTab.hasClass("active")){
                $thisRoleTab.attr("aria-selected", true);
            }else{
                $thisRoleTab.attr("aria-selected", false);
            }

            var obj = {
                name: $(this).attr("href").split("#")[1],
                $tabBtn: $(this),
                $tabPannel: $($(this).attr("href"))
            }
            tab.push(obj);

            $thisRoleTab.attr("id", obj.name + "Tab");
            $($targetRoleTabPanel[I]).attr("aria-labelledby", $thisRoleTab.attr("id"));
            $thisRoleTab.attr("aria-controls", $($targetRoleTabPanel[I]).attr("id"));
            $targetRoleTabList.attr("role", "presentation");
        })
    }
    tabAriaInner();
    //20200311 END 장영희 || Tab, Tabpanel 접근성 속성 추가 (Static Page Tab 공통)

    //20200323 START 장영희 || Static Page - CN yanbao.html 검색 기능
    //20200402 START 장영희 || Static Page - CN yanbao.html 검색 기능
    $(".yanbao-content .btn-submit-form").on("click", function(e){
        var $this = $(this),
            formThis = $this.parents(".validateForm");
            e.preventDefault();

        if(formThis.checkValidation()){

            var dataUrl = formThis.data("url"),
                formData = formThis.serialize(),
                $resultBox = formThis.find(".results-box"),
                resultBoxList = $resultBox.children(".results-default, .results-nodata, .results-list"),
                resultList = $resultBox.find(".results-list");

                // console.log(classNameSplit[1] = classNameSplit[1].replace(/^./, classNameSplit[1].substring(0,1).toUpperCase()), classNameSplit.join(""))

            $.ajax({
                type : "get",
                url: dataUrl,
                async: !1,
                dataType: "json",
                data : formData,
                success : function(e){
                    var obj = e;

                    if(!obj.contractNumber){
                        resultBoxList.css({"display":"none"});
                        $resultBox.find(".results-nodata").css({"display":"block"});
                    }else{
                        for (var prop in obj) {
                            resultList.find("span."+ prop).text(obj[prop])   
                        }
                        resultBoxList.css({"display":"none"});
                        resultList.css({"display":"block"});
                    }
                }
            })
        }else{
        }
    })
    //20200402 END 장영희 || Static Page - CN yanbao.html 검색 기능
    //20200323 END 장영희 || Static Page - CN yanbao.html 검색 기능
    
    //20200427 START 장영희 || Static Page - PH Hash URL 적용
    function tabhash(){
        var urlHash = window.location.hash.split("#tab=")[1],
            tabNameArr = [],
            $tab = $(".tab-wrap");

        $tab.find(".btn-tab[data-tab]").each(function(){
            tabNameArr.push(this.getAttribute('data-tab'));
        });

        $tab.find(".btn-tab[data-tab]").on("click", function(e){
            e.preventDefault();
            var scrollPos = $('html').scrollTop() || $('body').scrollTop();

            window.location.hash = "#tab=" + $(this).data("tab");
            $('html,body').scrollTop(scrollPos);
        });

        if(tabNameArr.indexOf(urlHash) < 0){ return };

        // tab button active
        $tab.find(".btn-tab[data-tab]").removeClass("active")
        $tab.find(".btn-tab[data-tab='" + urlHash + "']").addClass("active");

        // tab panel active
        $(".warranty-panel").removeClass("active");
        $(".warranty-panel#" + urlHash).addClass("active");
    }
    if(window.location.hash.indexOf("#tab=") >= 0){
        tabhash();
    }
    //20200427 ENd 장영희 || Static Page - PH Hash URL 적용

    // 200427 START  전호근 - TN : google map layer popup
    if ($('.tn-parts-product-list').length){
        var map, marker;
        var $modal = $('#partsAccessoriesLgMap');
        var script = document.createElement('script');
        script.src = '//maps.googleapis.com/maps/api/js?v=3.33&client=gme%2Dlgelectronicsinc1&region=TN&language=TN';
        document.body.appendChild(script);
        script.addEventListener('load', function() {
            map = new google.maps.Map(
                document.getElementById('repairMap'), {
                zoom: 14,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            });

            $('.address-popup').on('click', function(e) {
                var $this = $(this),
                    lat = $this.data('lat'),
                    lng = $this.data('lng');
                    
                map.setCenter( new google.maps.LatLng(lat, lng));
                map.setZoom(14);
                marker && marker.setMap(null);
                marker = new google.maps.Marker({
                    position: new google.maps.LatLng(lat, lng),
                    map: map
                });
                $modal.modal('show');
    
                e.preventDefault();
            });
        });
    }
    // 200427 END  전호근 - TN : google map layer popup

    //20200506 START 장영희 || Static Page WhatsApp video play icon click event
    $(".whatsapp-video-wrap").find(".see-video").on("click", function(){
        $(".whatsapp-video-wrap").find(".whatsapp-video").css({"display":"block"});
    })
    //20200506 START 장영희 || Static Page WhatsApp video play icon click event
});